import InputFieldSet from "PFComponents/text/input_field_set";
import Toggle from "PFComponents/toggle/toggle";
import React from "react";

type DisabledItems = {
  customFields: object;
  positions: object;
};

type InputProps = {
  data: any;
  prop: string;
  mergeData: (change: object) => void;
  disabledItems: DisabledItems;
  setDisabledItems: React.Dispatch<React.SetStateAction<DisabledItems>>;
  label: string;
  inputType?: string;
  error: string;
};

const Input = ({
  data,
  prop,
  mergeData,
  disabledItems,
  setDisabledItems,
  ...rest
}: InputProps): JSX.Element | null => {
  const isVisible = data[prop] || data[prop] === "" || data[prop] === 0;

  if (!isVisible) {
    return null;
  } else {
    return (
      <div style={{ display: "flex", width: "100%" }}>
        <InputFieldSet
          disabled={disabledItems[prop]}
          style={{ flex: 1 }}
          controlledValue
          handleChange={(val) => mergeData({ [prop]: val })}
          value={data[prop]}
          qaId={`ChangeRequest.About.${prop}`}
          {...rest}
        />
        <Toggle
          checked={!disabledItems[prop]}
          onChange={(val) => setDisabledItems((prev) => ({ ...prev, [prop]: !val }))}
        />
      </div>
    );
  }
};

export default Input;
